import EmptyWrap from "@/components/Gui/EmptyWrap";

export default [
    {
        path: 'subscription',
        component: EmptyWrap,
        children: [
            {
                path: '',
                name: 'subscription.list',
                component: require('@/views/Subscription/SubscriptionList').default,
            },
            {
                path: 'create',
                name: 'subscription.create',
                component: require('@/views/Subscription/SubscriptionForm').default,
            },
            {
                path: ':id',
                component: require('@/views/Subscription/Card/WrapBlock').default,
                children: [
                    {
                        path: 'detail',
                        name: 'subscription.detail',
                        component: require('@/views/Subscription/Card/SubscriptionDetail').default,
                    },
                    {
                        path: 'detail',
                        name: 'subscription.subusers',
                        component: require('@/views/Subscription/Card/SubscriptionSubUsers').default,
                    },
                    {
                        path: 'payments',
                        name: 'subscription.payments',
                        component: require('@/views/Subscription/Card/PaymentTab').default,
                    },
                    {
                        path: 'calls',
                        name: 'subscription.client-calls',
                        component: require('@/views/Subscription/Card/ClientCallTab').default,
                    },
                    {
                        path: 'promocode-use',
                        name: 'subscription.promocode-use',
                        component: require('@/views/Subscription/Card/PromocodeUseTab').default,
                    },
                ]
            },
            {
                path: ':id/edit',
                name: 'subscription.edit',
                component: require('@/views/Subscription/SubscriptionForm').default,
            },
        ]
    },
]
